import { useEffect } from 'react';
import {
    processAsResource,
    setIntervalAndExecute,
} from '../../Utils/utils'
import { useApolloClient } from "@apollo/client";
import { BackendURL, UPDATE_INTERVAL } from '../../Constants/AppData'
import { connect } from 'react-redux'

import { showToast } from "../../../actions/ui";
import { setSettings } from '../../../actions/settings'
import isElectron from 'is-electron'
import { UPDATES_QUERY } from "./Queries/UpdatesQuery";
import { PLAYLIST_QUERY } from "../Playlist/Queries/PlaylistQuery";
import { RESOURCE_QUERY } from "../Resource/Queries/resourceQuery";
import pkg from "../../../../../package.json";
// import { useHistory } from "react-router-dom";
// import log from "electron-log"

let electron;

if ( isElectron () ) {
    electron = window.require ( "electron" )
}
const ipcRenderer = electron && electron.ipcRenderer;

/*
 *  @Description:   Component with the only purpose of handling events.
 */

const EventHandler = ( props ) => {
    const client = useApolloClient ();

    const finishedCheckForSoftwareUpdates = () => {
        if ( isElectron () && props.isNetworkAvailable ) {
            // console.info( "'finishedCheckForSoftwareUpdates' receives 'data'" );
            // if ( data.value ) {
            //     // console.info( "There were updates. Notification was sent to the user" );
            //
            //     // Add programmable actions to toasts.
            //     // The toast is shown with a button that allows you to act upon the notification.
            //     // In this case, it will send the action to quitAndUpdate.
            //     // ipcRenderer.send( "quitImmediatelyAndUpdate", null); << this action has to be on utils.
            //     // on Main, we activate the autoupdater event for it.
            // } else {
            //     // console.info( "There arent new updates and the workflow finished" );
            // }
            // if (data.message !== "") {
            //     const obj = {
            //         toastTitle: "Notifications",
            //         toastMessage: "TEST MESSAGE",
            //     }
            //     props.showToast( obj )
            //     // console.info( data.message );
            // }

        }
    }

    useEffect ( () => {
        if ( isElectron () ) {
            if ( props.isNetworkAvailable ) {
                // console.info("Request downloaded items from local");
                // sendToLogger("Request downloaded items from local");
                setIntervalAndExecute ( getAllDownloadedItemsFromDB, UPDATE_INTERVAL );
                // console.info("Request software updates");
                // sendToLogger("Request software updates");
                setIntervalAndExecute ( checkForSoftwareUpdates, UPDATE_INTERVAL );
            }
            ipcRenderer.on ( "finishedGettingDownloadedItems", requestUpdates );
            ipcRenderer.on ( "finishedCheckForSoftwareUpdates", finishedCheckForSoftwareUpdates );
            // ipcRenderer.on( "removePlaylistFromDownloadQueue", checkIfPlaylistQueueClear );
        }
        return () => {
            if ( isElectron () ) {
                ipcRenderer.off ( "finishedGettingDownloadedItems", requestUpdates );
                ipcRenderer.off ( "finishedCheckForSoftwareUpdates", finishedCheckForSoftwareUpdates );
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [] );

    // const sendToLogger = (data) => {
    //     ipcRenderer.send("sendToLogger", data);
    // }
    // const onDownloadProgress = (event, info) =>{
    //     console.info( { "Download Progress": info })
    // }

    const deleteItems = ( itemsToDelete ) => {
        // console.info("Deletable: ", itemsToDelete);
        // sendToLogger("Deletable: ")
        // sendToLogger ( { itemsToDelete } );

        return new Promise ( ( resolve, reject ) => {
            try {
                itemsToDelete.forEach ( ( item ) => {
                    switch ( item.type ) {
                        case "playlist":
                            ipcRenderer.send ( "deletePlaylist", item.id );
                            return;
                        case "resource":
                            ipcRenderer.send ( "deleteResource", item.id );
                            return;
                        default:
                            return;
                    }
                } );
                resolve ( true )
            } catch ( error ) {
                console.error ( "Error on 'deleteItems'", error );
                reject ( false );
            }

        } )

    }

    const calculateUpdatableItems = ( itemsFromDatabase, itemsFromServer ) => {
        const itemsToVerifyUpdate = itemsFromDatabase.filter ( x => itemsFromServer.map ( item => item.id ).includes ( x.id ) );
        // console.info("itemsToVerifyUpdate: ", itemsToVerifyUpdate);

        return itemsToVerifyUpdate.map ( ( item ) => {
            const id = item.id;
            const element = itemsFromServer.find ( e => e.id === id );
            const shouldUpdate = item.entity_changed === element.entity_changed;

            // console.info( 'itemsToVerifyUpdate.item: ', id );
            // console.info("itemsFromServer.element: ", element);
            // console.info("shouldUpdate:\nEntity Changed DB:", item.entity_changed)
            // console.info("Entity Changed Server:", element.entity_changed)
            // console.info("\t\t",item.entity_changed !== element.entity_changed)

            return shouldUpdate ? false : element;
        } ).filter ( ( item ) => {
            return item !== false
        } );
    }

    const updateResources = ( resourcesToUpdate ) => {
        resourcesToUpdate.forEach ( ( resource ) => {
            client
                .query ( {
                    query: RESOURCE_QUERY,
                    variables: {
                        "id": String(resource.id)
                    },
                    options: { 'errorPolicy': 'ignore' }
                } )
                .then ( ( response ) => {
                    const info = response.data.nodeById;
                    if ( info.fieldResourceFilesByFormat.length > 0 ) {
                        const doc = processAsResource ( info );
                        doc.sessionToken = props.session.token;
                        ipcRenderer.send('CreateResource', doc);
                    }
                } )
                .catch ( error => {
                    console.error ( "Error on 'resourcesToUpdate' query: ", error )
                } )
        } );
    }

    const updatePlaylists = ( playlistsToUpdate ) => {
        playlistsToUpdate.forEach ( ( playlist ) => {
            client
                .query ( {
                    query: PLAYLIST_QUERY,
                    variables: {
                        "id": String(playlist.id)
                    },
                    options: { 'errorPolicy': 'ignore' }
                } )
                .then ( ( response ) => {
                    const playlistData = response.data.nodeById;

                    playlistData.backendURL = BackendURL;
                    ipcRenderer.send ( "storePlaylistMetadata", playlistData );
                } )
                .catch ( error => {
                    console.error ( "Error on 'playlistsToUpdate' query: ", error )
                } )
        } )

    }

    const requestUpdates = ( event, requestData ) => {
        // console.info( "Updates requested!" );
        // console.info("Parse downloaded items from local");
        // sendToLogger("Parse downloaded items from local");
        if ( props.isNetworkAvailable) {
            const itemsFromDatabase = requestData.filter ( item => item.type !== "playlisted-resource" )
            const itemIDsFromDatabase = itemsFromDatabase.map ( item => item.id );
            // console.info("Request content updates");
            // sendToLogger("Request content updates");
            client
                .query ( {
                    query: UPDATES_QUERY,
                    variables: {
                        "ids": itemIDsFromDatabase,
                        "limit": itemIDsFromDatabase.length + 1,
                        "offset": 0
                    },
                    options: { 'errorPolicy': 'ignore' }
                } )
                .then ( ( response ) => {
                    // console.info ( { response } )
                    if ( response.data.playlistsAndResourcesQuery !== null && response.data.playlistsAndResourcesQuery[0] !== null ) {
                        const itemsFromServer = response.data.playlistsAndResourcesQuery[0]
                            .filter ( item => item !== null )
                            .map ( ( item ) => {
                                return {
                                    id: item.id,
                                    type: item.type,
                                    entity_changed: Date.parse ( item.entity_changed )
                                }
                            } )

                        if ( itemsFromServer.length > 0 ) {
                            deleteItems ( itemsFromDatabase.filter ( x => !itemsFromServer.map ( item => item.id ).includes ( x.id ) ) )
                                .then ( ( response ) => {
                                    if ( response === true ) {
                                        const updatable = calculateUpdatableItems ( itemsFromDatabase, itemsFromServer );
                                        // console.info ( "Updatable:" );
                                        // console.table ( updatable );
                                        // sendToLogger ( "Updatable:" );
                                        // sendToLogger ( { updatable } );
                                        if ( updatable.length === 0 ) {
                                            ipcRenderer.send ( 'updateVerifyMessage', {
                                                type: "text",
                                                data: "No new updates"
                                            } );
                                        }
                                        updateResources ( updatable.filter ( item => item.type === "resource" ) );
                                        updatePlaylists ( updatable.filter ( item => item.type === "playlist" ) );
                                    } //else {}
                                } )
                                .then ( () => {
                                    ipcRenderer.send ( "updateLastVerifyDate", null );
                                } )
                                .catch ( ( error ) => {
                                    console.error ( "Error on 'requestForUpdates' on 'deleteItems' promise: ", error )

                                } )
                        }
                    } else {
                        // Server sends null, there must not be any updates so
                        ipcRenderer.send ( 'updateVerifyMessage', {
                            type: "text",
                            data: "No new updates"
                        } );
                        ipcRenderer.send ( "updateLastVerifyDate", null );
                    }
                } )
                .catch ( ( error ) => {
                    console.error ( "Error in 'requestUpdates': ", error );
                    // TODO: Remove when there's a way to detect if the token has failed and when there's a way to refresh a token.
                    window.localStorage.removeItem("token");
                    window.localStorage.removeItem("username");
                    window.localStorage.removeItem("isEmployee");
                   // window.location.reload();
                } )
        }
    }

    const getAllDownloadedItemsFromDB = () => {
        ipcRenderer.send ( "getDownloadedItems", "items" );
    }

    const checkForSoftwareUpdates = () => {
        ipcRenderer.send ( "checkForSoftwareUpdates", pkg.version );
    }

    return null;

}

const mapStateToProps = ( state ) => (
    {
        playlist: state.playlist,
        session: state.session,
        isNetworkAvailable: state.sensors.isNetworkAvailable,
    } );

export default connect ( mapStateToProps, {
    setSettings,
    showToast
} ) ( EventHandler );
